import { LE } from "@/constants/enums";
import { assignFilesAndDocsByDocType, FileDocPropertyName } from "@modernary/mui/components/document";
import { fillLookupValuesByPropertyNames } from "@modernary/mui/components/lookup";
import type { Release } from "./release";

export default {
  addAuthRequestFields,
  skinnyResponseAdapter,
  responseAdapter,
  getInitialData,
  toFormkit,
  fromFormkit,
};

function addAuthRequestFields(entity: Release) {
  entity._authRequestFields = ["id", "facilityId", "statusMurn"] as (keyof Release)[];
  return entity;
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Release }) {
  addAuthRequestFields(response.data);
  await fillLookupValuesByPropertyNames(response.data, ["sourceMurn"]);
  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Release }) {
  await skinnyResponseAdapter(response);

  return response.data;
}

function getInitialData() {
  const result = {} as Release;
  return addAuthRequestFields(result);
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: Release) {}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: any) {}
